angular.module('jv.candidate.details.app', []);